import { Link } from "gatsby"
import React from "react"
import { IoWifi } from "react-icons/io5"
import PimImage from "../../atoms/PimImage"
import BgColor, { HarviaBackgroundColor } from "../../layouts/BgColor"
import * as styles from "./ProductCard.module.scss"
import { textFormat } from "./utils"

export type ProductCardProps = {
  url: string // luodaan linkki tämän perusteella
  image?: string
  imageAlt?: string
  group?: string
  family?: string
  title: string
  text?: string
  tags?: string[]
  labels?: Label[]
  itemCode?: string
  wifi?: boolean
}

type Label = { label: string; color: HarviaBackgroundColor }

const TagBox = (props: { label: string }) => {
  return <span className={styles.tag}>{props.label}</span>
}

const LabelBox = (props: Label) => {
  return (
    <BgColor color={props.color} className={styles.label}>
      {props.label}
    </BgColor>
  )
}

const ProductCard = (props: ProductCardProps) => {
  //console.log('Rendering ProductCard', props)

  return (
    <div className={styles.container} itemScope itemType="https://schema.org/Product">
      <Link to={props.url} tabIndex={-1}>
        <PimImage src={props.image} alt={props.imageAlt} className={styles.image} itemProp="image" />
        <div className={styles.labels}>
          {props.labels?.map((itm: Label, i: number) => {
            return <LabelBox key={i} {...itm} />
          })}
        </div>

        {props.wifi && <IoWifi className={styles.wifi} title="Wifi" />}
      </Link>
      <div className={styles.textArea}>
        <div className={styles.category} itemProp="category">
          {[props.group, props.family].filter(e => e).join(" | ")}
        </div>

        <h3 className={styles.title} itemProp="name">
          <Link to={props.url}>{textFormat(props.title)}</Link>
        </h3>

        <div className={styles.sku} itemProp="sku">
          {props.itemCode}
        </div>
        {props.text && <div dangerouslySetInnerHTML={{ __html: props.text }} itemProp="description" />}

        <div className={styles.tags}>
          {props.tags?.map(itm => (
            <TagBox key={itm} label={itm} />
          ))}
        </div>
      </div>
    </div>
  )
}

export default ProductCard
